module.exports = __webpack_public_path__ + "static/media/hero_image.75ee62a9.jpg";